import { useState, useEffect } from "react";
import { FaChevronLeft, FaTh, FaList } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import Document from "../../components/document";
import axios from "axios";
import { GetDocument } from "../../Services";

const DriverDocument = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [driverDocs, setDriverDocs] = useState([]);

  const { driver } = location.state || {};

  const driverDocuments = Array.isArray(driver?.documents)
    ? driver.documents.flat()
    : [];
  // console.log("driver doc: ", driverDocuments);

  useEffect(() => {
    const fetchDriverDocuemnt = async () => {
      setLoading(true);
      try {
        const res = await GetDocument.fetchDocumentType();
        const docs = res.data;
        setDriverDocs(docs.filter((doc) => doc.appliesTo === "DRIVER"));
        // console.log("Vehicles", docs);
      } catch (error) {
        console.error("Error fetching dispatcher:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchDriverDocuemnt();
  }, []);

  const handleAddDocument = (doc) => {
    console.log(`Add Document clicked for: ${doc.name}`);
  };

  return (
    <div className="content-wrapper p-4">
      <h2 className="text-2xl font-bold">
        Documents for {driver ? driver.name : "Driver"}
      </h2>

      <div className="card mt-4">
        <div className="card-header flex justify-between items-center">
          <button
            type="button"
            onClick={() => navigate("/drivers")}
            className="btn btn-outline-secondary flex items-center h-10 btn-sm"
          >
            <FaChevronLeft className="mr-1" /> Back
          </button>
          {/* <div className="flex gap-2"> */}
          <button
            type="button"
            className="btn btn-outline-secondary btn-sm ml-4"
          >
            <FaTh />
          </button>
          <button
            type="button"
            className="btn btn-outline-secondary btn-sm ml-2"
          >
            <FaList />
          </button>
          {/* </div> */}
        </div>

        <div className="card-body p-4">
          <div className="border border-gray-200 rounded-lg">
            <div className="bg-blue-50 p-3 border-b border-gray-200">
              <h3 className="text-lg font-semibold">Driver Documents</h3>
            </div>

            <div className="p-4">
              <div className="row">
                {driverDocs.length > 0 ? (
                  driverDocs.map((doc) => {
                    // Check if driver already has this document type
                    const existing = driverDocuments.find(
                      (d) => d.documentTypeId === doc.id
                    );

                    // {
                    //   console.log("exising ", existing, driverDocs);
                    // }
                    return (
                      <div key={doc.id} className="col-md-4 col-12 mb-3">
                        <Document
                          title={doc.name}
                          message={
                            existing
                              ? `Document already uploaded.`
                              : `${doc.name} not found.`
                          }
                          buttonText={
                            existing ? "View Document" : "Add Document"
                          }
                          appliesTo="DRIVER"
                          driver={driver}
                          documentId={doc.id}
                          existingDoc={existing}
                          onAdd={() => handleAddDocument(doc)}
                        />
                      </div>
                    );
                  })
                ) : (
                  <p className="text-gray-500">
                    No active driver documents found.
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DriverDocument;
